import React from 'react';

export default class ExportExcelButton extends React.Component {
    handleClick = () => {
        if (this.props.onClick) {
            this.props.onClick();
        }
    };

    render() {
        return (
            <div>
                <span
                    className="icon-download headerIcon"
                    onClick={this.handleClick}
                    style={{
                        background: '#04764e',
                        borderRadius: '50%', padding: '7px',
                        cursor: 'pointer',
                        userSelect: 'none',
                        fontSize: '22px',
                        lineHeight: '36px',
                    }}>

                </span>
            </div>
        );
    }
}
